class BESSAppProjectDependencyWithSubDependency extends BESSAppProjectDependency {

    constructor(owner, dependency) {
        super();
        this.owner = owner;
        this.dependency = dependency;
        this.subDependency = dependency.subDependency;
        this.qId1Event = BESSAppQuestionAnswerDependencyEvent.eventFor(this.dependency.questionIdentifier);
        this.qId2Event = BESSAppQuestionAnswerDependencyEvent.eventFor(this.subDependency.questionIdentifier);

        this.qId1EventValueIs = this.dependency.questionValue !== undefined ? questionValueIs(this.dependency.questionValue) : questionValueIsAnswered;
        this.qId2EventValueIs = this.subDependency.questionValue !== undefined ? questionValueIs(this.subDependency.questionValue) : questionValueIsAnswered;

        let dependencyHandler = new BESSAppProjectVisibilityDependencyHandler(
            this.owner.node,
            this.isEnabled.bind(this),
            this.owner.getShowIfFn(dependency));

        this.subscribeToEvents(this.qId1Event, (x) => dependencyHandler.handle(x));
        this.subscribeToEvents(this.qId2Event, (x) => dependencyHandler.handle(x));
    }

    isEnabled() {
        return false;
    }
}